import { checkAppVersion } from "@flights/web-api-utils-universal";
import { clientPayload as etClientPayload } from "@flights/et-universal";
import { getMarketingTrackingVariable, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { X_BOOKING_FLIGHTS_DEV_SERVICE_OVERRIDE, X_BOOKING_FLIGHTS_CLIENT_HINTS } from "@flights/constants";
import { devOverrideUtils } from "@flights/web-api-utils-universal";
import { appendFeatureAndExperimentParams, appendLanguageOptionParam } from "./utils.js";
export class ClientFetchError extends Error {
    constructor(message) {
        super(message);
        this.name = "ClientFetchError";
    }
}
export class ClientFetchNotAuthorizedError extends ClientFetchError {
    constructor(message) {
        super(message);
        this.name = "ClientFetchNotAuthorizedError";
    }
}
function getFetchApi() {
    if (isFeatureRunningClientSide("FLIGHTS_WEB_ENABLE_AWS_WAF_FETCH_WRAPPER") && !!window?.AwsWafIntegration?.fetch) {
        return window.AwsWafIntegration.fetch;
    }
    return window.fetch;
}
export function clientFetch(...args) {
    const { debugAllExtraProducts, marketingTrackingVariables: trackingVariables, emkToken, isInternal, env, soylentEmail, tracingHeaders } = window.__GLOBAL_CONTEXT__;
    const [url, options = {}] = args;
    let { headers = {} } = options;
    headers = { ...headers, ...tracingHeaders };
    headers["X-Requested-From"] = "clientFetch";
    const aid = getMarketingTrackingVariable("aid") || trackingVariables?.aid;
    const label = getMarketingTrackingVariable("label") || trackingVariables?.label;
    const distributionId = getMarketingTrackingVariable("distribution_id") || trackingVariables?.distributionId;
    const etgTestUrl = sessionStorage && sessionStorage.getItem("debugEtgUrl");
    const debugAllTravelerDataRequirements = sessionStorage && sessionStorage.getItem("debugAllTravelerDataRequirements");
    if (aid) {
        headers["X-Booking-Affiliate-Id"] = aid;
    }
    if (label) {
        headers["X-Booking-Label"] = label;
    }
    if (emkToken) {
        headers["X-Booking-EMK-Token"] = emkToken;
    }
    if (debugAllExtraProducts) {
        headers["X-Flights-Debug-All-Products"] = "1";
    }
    if (soylentEmail) {
        headers["X-Soylent-Email"] = soylentEmail;
    }
    if (etgTestUrl) {
        headers["X-Flights-Debug-Etg-Test-Url"] = etgTestUrl;
    }
    if (debugAllTravelerDataRequirements) {
        headers["X-Flights-Debug-All-Traveler-Data-Requirements"] = "1";
    }
    if (distributionId) {
        headers["X-Booking-Distribution-Id"] = distributionId;
    }
    const hints = ["price_change_v2"];
    headers[X_BOOKING_FLIGHTS_CLIENT_HINTS] = hints.join(",");
    if (env !== "prod") {
        const devOverrides = devOverrideUtils.getAll();
        if (typeof devOverrides == "object" && Object.keys(devOverrides).length) {
            headers[X_BOOKING_FLIGHTS_DEV_SERVICE_OVERRIDE] = JSON.stringify(devOverrides);
        }
    }
    if (!options.credentials) {
        options.credentials = "same-origin";
    }
    let apiPrefix = "";
    if (String(url).startsWith("/")) {
        apiPrefix = window.__GLOBAL_CONTEXT__?.apiPrefix;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const a11yMobileView = urlParams.get("a11y_mobile_view");
    if (a11yMobileView === "1") {
        headers["X-Booking-A11y-Mobile-View"] = "1";
    }
    let fetchUrl = String(url);
    if (a11yMobileView === "1") {
        const urlObj = new URL(fetchUrl, window.location.origin);
        urlObj.searchParams.set("a11y_mobile_view", "1");
        fetchUrl = urlObj.toString();
    }
    if (isInternal)
        fetchUrl = appendFeatureAndExperimentParams(fetchUrl);
    fetchUrl = apiPrefix + appendLanguageOptionParam(fetchUrl);
    const fetchApi = getFetchApi();
    return fetchApi(fetchUrl, { ...options, headers })
        .then((res) => {
        etClientPayload.updateClientSideContext(res.headers.get("X-Booking-Experiment-Soylent-Payload"));
        checkAppVersion.checkForAppVersionMismatch(res.headers.get("X-Booking-App-Version"));
        if (res.ok) {
            if (res.headers.get("Content-Type") === "application/pdf") {
                return res.blob();
            }
            return res.json();
        }
        else {
            if (res.status === 403) {
                throw new ClientFetchNotAuthorizedError("Fetch: Not Authorized");
            }
            else {
                throw new ClientFetchError("Fetch: Non-OK response");
            }
        }
    })
        .then((data) => {
        etClientPayload.checkForNewClientsidePayload(data?._meta?._clientsidePayload);
        if (data.error) {
            throw data.error;
        }
        return data;
    });
}
